import React from 'react';
import styles from './LegalTerms.css.js';
import Radium from 'radium';

const LegalTerms = ({ email, isSearch, optOut }) => (
    <div style={styles.termsContainer}>
        <div style={styles.termsText}>
            {isSearch ? 
                `By clicking the “Find Offers” button, or any of the links above, I agree with the ` : 
                `By clicking any of the links above, ` 
            }
            {/* <a 
                key='terms-privacy-policy-1'
                style={styles.termsLink}
                href='https://unitedstatescredit.com/privacy' 
                rel='noopener noreferrer' 
                target='_blank'
            >
                Privacy Policy
            </a>
            {` and `}
            <a 
                key='terms-policy'
                style={styles.termsLink} 
                href='https://unitedstatescredit.com/terms' 
                rel='noopener noreferrer' 
                target='_blank'
            >
                Terms &amp; Conditions</a>. */}
            {!optOut && <> {`I consent to receive emails ${email && email !== 'omit' ? `to ${email}` : ''}
            from UnitedStatesCredit.com in accordance with their `}
            <a 
                key='terms-privacy-policy-2'
                style={styles.termsLink} 
                href='https://unitedstatescredit.com/privacy' 
                rel='noopener noreferrer' 
                target='_blank'
            >
                Privacy Policy.
            </a>
                {` I also agree with UnitedStatesCredit.com `}
            <a 
                key='terms-policy'
                style={styles.termsLink} 
                href='https://unitedstatescredit.com/terms' 
                rel='noopener noreferrer' 
                target='_blank'
                >
                Terms &amp; Conditions
            </a>
            {` and `}
            <a 
                key='terms-privacy-policy-3'
                style={styles.termsLink} 
                href='https://unitedstatescredit.com/privacy' 
                rel='noopener noreferrer' 
                target='_blank'
            >
                Privacy Policy.
            </a>
            </>}
        </div>
    </div>
);

export default Radium(LegalTerms);